import {
  completeFieldNavigationTiming,
  failFieldNavigationTiming,
  hasPendingFieldNavigation,
} from "./fieldNavigationTiming";
import { useTrackPendingQuery, type PendingQueryState } from "./pendingQueryTracking";

export interface PendingFieldNavigationQueryState extends PendingQueryState {}

const fieldNavigationQueryTracker = {
  hasPending: hasPendingFieldNavigation,
  complete: completeFieldNavigationTiming,
  fail: failFieldNavigationTiming,
  unknownErrorMessage: "Unknown field navigation error",
};

export function useTrackPendingFieldNavigation(
  id: string,
  state: PendingFieldNavigationQueryState,
) {
  useTrackPendingQuery(id, state, fieldNavigationQueryTracker);
}
